/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DashboardInputs */

const id_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor`)
};

const ms_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papan Pemuka`)
};

const da_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const de_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const en_us2_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const es_es2_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const es_mx2_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablero`)
};

const fil_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const fr_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const it_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const hu_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irányítópult`)
};

const nl_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const no_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashbord`)
};

const pl_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const pt_br2_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const pt_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const ro_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panou de bord`)
};

const fi_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallintapaneeli`)
};

const sv_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const vi_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng điều khiển`)
};

const tr_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const cs_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const bg_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Табло`)
};

const ru_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель`)
};

const uk_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель`)
};

const ar_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة التحكم`)
};

const hi_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डैशबोर्ड`)
};

const th_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แดชบอร์ด`)
};

const ja_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボード`)
};

const zh_cn2_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪表盘`)
};

const zh_hant1_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儀表板`)
};

const ko_nav_dashboard = /** @type {(inputs: Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Nav_DashboardInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_dashboard = /** @type {((inputs?: Nav_DashboardInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DashboardInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_dashboard(inputs)
	if (locale === "ms") return ms_nav_dashboard(inputs)
	if (locale === "da") return da_nav_dashboard(inputs)
	if (locale === "de") return de_nav_dashboard(inputs)
	if (locale === "en-US") return en_us2_nav_dashboard(inputs)
	if (locale === "es-ES") return es_es2_nav_dashboard(inputs)
	if (locale === "es-MX") return es_mx2_nav_dashboard(inputs)
	if (locale === "fil") return fil_nav_dashboard(inputs)
	if (locale === "fr") return fr_nav_dashboard(inputs)
	if (locale === "it") return it_nav_dashboard(inputs)
	if (locale === "hu") return hu_nav_dashboard(inputs)
	if (locale === "nl") return nl_nav_dashboard(inputs)
	if (locale === "no") return no_nav_dashboard(inputs)
	if (locale === "pl") return pl_nav_dashboard(inputs)
	if (locale === "pt-BR") return pt_br2_nav_dashboard(inputs)
	if (locale === "pt") return pt_nav_dashboard(inputs)
	if (locale === "ro") return ro_nav_dashboard(inputs)
	if (locale === "fi") return fi_nav_dashboard(inputs)
	if (locale === "sv") return sv_nav_dashboard(inputs)
	if (locale === "vi") return vi_nav_dashboard(inputs)
	if (locale === "tr") return tr_nav_dashboard(inputs)
	if (locale === "cs") return cs_nav_dashboard(inputs)
	if (locale === "bg") return bg_nav_dashboard(inputs)
	if (locale === "ru") return ru_nav_dashboard(inputs)
	if (locale === "uk") return uk_nav_dashboard(inputs)
	if (locale === "ar") return ar_nav_dashboard(inputs)
	if (locale === "hi") return hi_nav_dashboard(inputs)
	if (locale === "th") return th_nav_dashboard(inputs)
	if (locale === "ja") return ja_nav_dashboard(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_dashboard(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_dashboard(inputs)
	return ko_nav_dashboard(inputs)
});
export { nav_dashboard as "nav.dashboard" }